import React, { useLayoutEffect } from 'react';
import {Routes, Route, Router, useLocation} from 'react-router-dom';
import {
  ROOT_URL,
  ABOUT_ME_URL,
  SERVICES_URL,
  CONTACT_URL,
  TESTIMONIALS_URL,
} from '../constants/urls'
import HomepageView from '../views/homepage/HomepageView'
import Services from '../views/services/Services'
import ContactMe from '../views/contact-me/ContactMe'
import NotFound from '../views/errors/NotFound'
import AboutMe from '../views/about-me/AboutMe'
import Testimonials from '../views/testimonials/Testimonials'
import MainLayout from './layouts/MainLayout'

const Wrapper = ({ children }) => {
  const location = useLocation();

  useLayoutEffect(() => {
    // Scroll to the top of the page when the route changes
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [location.pathname]);

  return children;
};

const AppRoute = () => {
  return (
    <Wrapper>
      <Routes>
        <Route path='*' element={<MainLayout> <NotFound/> </MainLayout>} />
        <Route path={ROOT_URL} element={<MainLayout> <HomepageView/> </MainLayout>} />
        <Route path={ABOUT_ME_URL} element={<MainLayout> <AboutMe/> </MainLayout>} />
        <Route path={SERVICES_URL} element={<MainLayout> <Services/> </MainLayout>} />
        <Route path={TESTIMONIALS_URL} element={<MainLayout> <Testimonials/> </MainLayout>} />
        <Route path={CONTACT_URL} element={<MainLayout> <ContactMe/> </MainLayout>} />
        <Route element={<MainLayout> <NotFound/> </MainLayout>} />
      </Routes>
    </Wrapper>
  )
}

export default AppRoute